import axios from 'axios';
import { BaseService } from '@/core/base-service';

export default class FavoriteService extends BaseService<any> {
	public constructor() {
		super('services/servicepze/api/favorite');
	}

	public getOptions(): Promise<any> {
		return axios.get(this.endpointName + '/combobox');
	}
}
